import React from "react";
import { Images } from "../assets";
import classes from "./style.module.scss";
import { useLocation } from "react-router-dom";

export const AuthLayout = (props) => {
  const location = useLocation();
  const imagehandler = location.pathname.includes("login");
  const isSuccess = location.pathname.includes("success");
  const isRedirect = location.pathname.includes("redirect") || location.pathname.includes("delete-account") || location.pathname.includes("delete-user");

  return (
    <>
      <div className={`${classes.loginpage}`}>
        {!isSuccess && !isRedirect && (
          <div className={`${classes.left}`}>

            {imagehandler ? (
              <img src={Images.gif} className={`${classes.gif}`} />
            ) : (
              <div className="w-[100%] h-[100%] border-[#D9D9D9] rounded-r-3xl relative z-20 border-[1px]">
                <img
                  src={Images.forgotPasswordImg}
                  className={`${classes.img} overflow-hidden rounded-r-[3%]`}
                />
              </div>
            )}

          </div>
        )}

        <div className={!isSuccess && !isRedirect ? `${classes.right}` : `${classes.full}`}>
          {props?.children}
        </div>
      </div>
      <div>
        <img src={Images.colorBar} className={`${classes.colorBar}`} />
      </div>
    </>
  );
};
